/**
 * Utilidades de formato para moneda y fechas (NFR-MONEY-1, NFR-I18N-1).
 *
 * El dinero se representa siempre con bigint en unidades minimas.
 * Esta capa solo formatea para presentacion en pantalla.
 */

import type { Money } from "../core/money.js";

export function formatMoney(money: Money): string {
  const isNegative = money.amountMinor < 0n;
  const absMinor = isNegative ? -money.amountMinor : money.amountMinor;

  const divisor = 10n ** BigInt(money.scale);
  const units = absMinor / divisor;
  const fractions = absMinor % divisor;

  const fractionStr = fractions.toString().padStart(money.scale, "0");

  // Formato español: punto para miles, coma para decimales
  const unitsFormatted = units.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  const sign = isNegative ? "-" : "";

  const symbol = money.currency === "EUR" ? "€" : money.currency === "USD" ? "$" : money.currency === "PEN" ? "S/" : money.currency;

  return `${sign}${unitsFormatted},${fractionStr} ${symbol}`;
}

export function formatMinorUnits(amountMinor: bigint, currency = "PEN", scale = 2): string {
  return formatMoney({ amountMinor, currency, scale });
}

export function formatDate(isoDate: string): string {
  if (!isoDate) return "";
  const parts = isoDate.split("-");
  if (parts.length === 3) {
    const [y, m, d] = parts;
    return `${d}/${m}/${y}`;
  }
  return isoDate;
}

export function formatDateTime(isoDateTime: string): string {
  if (!isoDateTime) return "";
  try {
    const d = new Date(isoDateTime);
    return d.toLocaleString("es-ES", {
      dateStyle: "short",
      timeStyle: "short",
    });
  } catch {
    return isoDateTime;
  }
}
